import { writable } from "svelte/store";

export const showSearchSignpostBanner = writable(false);
